import individualReportArticleApi from "@/api/article/individualReportArticleApi";

export default {
  namespaced: true,
  actions: {
    async addOrDelete({dispatch}, {reportId, form}) {
      try {
        const response = await individualReportArticleApi.addOrDelete(reportId, form);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch({dispatch}, {reportId}) {
      try {
        const response = await individualReportArticleApi.fetch(reportId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
